import React, { PropTypes, forwardRef, useState } from 'react';
// import shouldPureComponentUpdate from 'react-pure-render/function';
import icon_calendar from '../images/icon-calendar.svg';
// import { greatPlaceStyle, greatPlaceStyleHover } from './my_great_place_with_hover_styles.js';
import ReactDatePicker from 'react-datepicker';


import "react-datepicker/dist/react-datepicker.css";
import { Dropdown } from 'react-bootstrap'
import { utils } from '../utils/utils'
// CustomDateSelect.propTypes = {
//     // GoogleMap pass $hover props to hovered components
//     // to detect hover it uses internal mechanism, explained in x_distance_hover example
//     hover: PropTypes.bool,
//     text: PropTypes.string
// };

const CustomDateSelect = (props) => {
    const { onChange, dateRange } = props
    // const [startDate, setStartDate] = useState(new Date());
    // const [endDate, setEndDate] = useState(null);
    // const onChange = (dates) => {
    //     const [start, end] = dates;
    //     setStartDate(start);
    //     setEndDate(end);
        
    // };
    // onChange={date => this.setState({ scheduleDate: date }) || console.log(Number(utils.convertDateToTimeStamp(this.state.scheduleDate)))}
    // console.log(startDate)
    const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
        <>

            <Dropdown className="clearfix example-custom-input" onClick={onClick} ref={ref}>
                <span className='float-left p-1 mr-2'>แสดงข้อมูลวันล่าสุด { value }</span>
                <Dropdown.Toggle variant="outline-light" id="dropdown-basic" className='float-right d-flex align-items-center p-1 text-dark border-0'>
                    <img
                        width={24}
                        height={24}
                        src={icon_calendar}
                        alt=""
                    />
                </Dropdown.Toggle>
            </Dropdown>
        </>
    ));
    return (
        <ReactDatePicker
            dateFormat="dd/MM/yyyy"
            selected={dateRange[0]}
            startDate={dateRange[0]}
            endDate={dateRange[1]}
            onChange={onChange}
            selectsRange
            customInput={<ExampleCustomInput />}
        />
    );
};
export default CustomDateSelect;